import URL from '../url'
import Request from '../request'

export const excelExportAutoSenderReportService = autoSenderId =>
  new Request(URL.REPORT_API, URL.EXCEL_EXPORT_AUTO_SENDER_REPORTS).post(
    {
      courseId: autoSenderId,
    },
    {
      responseType: 'blob',
    },
  )
export const excelExportCourseTimeSeriesReportService = () =>
  new Request(URL.REPORT_API, URL.EXCEL_EXPORT_COURSE_TIME_SERIES_REPORT).post(
    {},
    {
      responseType: 'blob',
    },
  )
export const excelExportCourseStatisticsReportService = () =>
  new Request(URL.REPORT_API, URL.EXCEL_EXPORT_COURSE_STATISTICS_REPORT).post(
    {},
    {
      responseType: 'blob',
    },
  )

export const excelExportCourseCollectionAnalyticsService = collectionId =>
  new Request(
    URL.REPORT_API,
    URL.DOWNLOAD_COLLECTION_EXCEL.replace('{collectionId}', collectionId),
  ).post(
    {
      collectionId,
    },
    {
      responseType: 'blob',
    },
  )
